import { createRouter, createWebHistory, RouteRecordRaw } from "vue-router";
import HomeView from "../views/HomeView.vue";
import LoginView from "../views/LoginView.vue";
import UnauthorizedView from "../views/UnauthorizedView.vue";
import SettingsView from "../views/SettingsView.vue";
import { useAuthGuard } from "@/composables/useAuthGuard";

const routes: Array<RouteRecordRaw> = [
  {
    path: "/",
    redirect: "/home"
  },
  {
    path: "/home",
    name: "home",
    component: HomeView,
    meta: { requiresAuth: true, requiresAuthorization: true }
  },
  {
    path: "/login",
    name: "login",
    component: LoginView,
    meta: { requiresAuth: false }
  },
  {
    path: "/unauthorized",
    name: "unauthorized",
    component: UnauthorizedView,
    meta: { requiresAuth: true, requiresAuthorization: false }
  },
  {
    path: "/settings",
    name: "settings",
    component: SettingsView,
    meta: { requiresAuth: true, requiresAuthorization: true }
  },
  {
    path: "/about",
    name: "about",
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ "../views/AboutView.vue"),
    meta: { requiresAuth: false }
  },
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
});

// Use centralized auth guard
const { authGuard } = useAuthGuard();
router.beforeEach(authGuard);

export default router;
